import { QuestionBase } from './question-base';

/*

Sample:

new RadiobuttonQuestion({
  key: 'genre',
  label: 'nouns.genre',
  value: student ? student.genre : null,
  options: [
    {label: 'Male',  value: 'male'},
    {label: 'Female',  value: 'female'}
  ],
  order: 5
})

*/
export class RadiobuttonQuestion extends QuestionBase<string> {
  controlType = 'radiobutton';
  options: { label: string; value: any }[] = [];

  constructor(options: {} = {}) {
    super({ ...options, designSystem: true });
    this.options = options['options'] || [];
    this.action = options['action'];
  }
}
